var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostesP10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1145.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Degradado_sin_nombre_11);}.cls-2{fill:#a2a1a1;}.cls-3{fill:#cfcfcf;}.cls-4{clip-path:url(#clippath);}.cls-5{fill:#afafaf;}.cls-6{fill:none;}.cls-7{fill:#009ee2;}.cls-8{fill:url(#Degradado_sin_nombre_11-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 540,
    cy: 591.35,
    r: 457.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_11",
    x1: 460.77,
    y1: 123.22,
    x2: 565.68,
    y2: -22.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#a2a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#abaaaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#afafaf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_11-2",
    x1: 460.73,
    y1: 196.94,
    x2: 565.42,
    y2: 51.46,
    xlinkHref: "#Degradado_sin_nombre_11"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    y: 21.43,
    width: 1080,
    height: 1080
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 540,
    cy: 591.35,
    r: 457.71
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M551.84,1139.25l17.84-10.11L528.69,76.89l-79.23-26.01-.08,1042.55c0,7.1,3.72,13.67,9.81,17.32l46.67,27.95c14.11,8.45,31.67,8.66,45.97,.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M616.59,48.42L543.02,5.52c-8.39-4.21-19.5-7.53-28.24-4.1l-45.33,24.4,66.1,54.65,81.03-32.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M592.73,1116.08c14.76-8.36,23.93-23.98,24.05-40.95l4.89-1015.78c0-9.82-9.96-16.5-19.05-12.78l-73.94,42.24V1115.97c.01,16.25,17.54,26.46,31.67,18.45l32.38-18.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M476.55,22.85l94.88,41.55-27.56,15.63c-9.49,5.16-15.36,15.12-15.3,25.92h0l-79.31-43.77,.04-9.06c.05-10.98,6.5-20.92,16.52-25.44l10.73-4.84Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 576.53,
    cy: 188.46,
    rx: 9.26,
    ry: 11.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 576.53,
    cy: 403.28,
    rx: 9.26,
    ry: 11.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 576.53,
    cy: 618.1,
    rx: 9.26,
    ry: 11.56
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "561.74 1005.97 528.52 150.76 449.46 124.72 449.39 1005.97 561.74 1005.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M616.25,122.27l-73.42-42.93c-8.38-4.21-19.46-7.54-28.19-4.11l-45.24,24.42,65.97,54.7,80.87-32.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M617.13,1005.97l4.19-872.76c0-9.83-9.94-16.51-19.01-12.79l-73.79,42.27,.17,843.27h88.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M476.48,96.67l94.69,41.59-27.5,15.65c-9.47,5.17-15.33,15.13-15.27,25.94h0l-79.15-43.81,.04-9.07c.05-10.99,6.49-20.94,16.48-25.46l10.71-4.84Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 576.27,
    cy: 262.42,
    rx: 9.24,
    ry: 11.57
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 576.27,
    cy: 403.54,
    rx: 9.24,
    ry: 11.57
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 576.27,
    cy: 618.53,
    rx: 9.24,
    ry: 11.57
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostesP10);
export default __webpack_public_path__ + "static/media/postes_p10.c1e45ea9448c1c5da08d0ab446d76e51.svg";
export { ForwardRef as ReactComponent };